import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Calendar, Users, Globe } from "lucide-react";
import { api, money } from "../lib/api";
import { track } from "../lib/analytics";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

const CATS = ["Tümü", "Çocuk", "Genç", "Ebeveyn", "Öğretmen", "Lider", "Yetişkin", "Kitap & düşünce buluşmaları"];

export default function Events() {
  const [all, setAll] = useState([]);
  const [active, setActive] = useState("Tümü");
  useEffect(() => { api.get("/events").then(({ data }) => setAll(data)).catch(() => {}); }, []);
  const items = active === "Tümü" ? all : all.filter((e) => e.category === active);

  return (
    <>
      <Seo title="Etkinlikler" description="Bilgece atölye ve etkinlik takvimi. Çocuk, ebeveyn, öğretmen ve lider atölyeleri, kitap ve düşünce buluşmaları." />
      <section className="pt-36 pb-14 bg-brand-green text-brand-offwhite grain relative overflow-hidden">
        <div className="container-narrow px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">Bilgece Etkinlikler</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light">Yaklaşan atölyeler</h1>
          <p className="text-brand-offwhite/75 mt-5 max-w-2xl leading-relaxed">Birlikte düşünmenin, deneyimlemenin ve dönüşmenin buluşmaları. Sana uygun olanı seç, yerini ayırt.</p>
        </div>
      </section>

      <section className="pt-12 pb-24 px-6 sm:px-10 lg:px-16 bg-brand-offwhite">
        <div className="container-narrow">
          <div className="flex flex-wrap gap-2 mb-12">
            {CATS.map((c) => (
              <button key={c} onClick={() => setActive(c)} data-testid={`event-filter-${c}`}
                className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${active === c ? "bg-brand-green text-brand-offwhite border-brand-green" : "bg-brand-cream text-brand-text/70 border-brand-gold-light/40 hover:border-brand-gold"}`}>{c}</button>
            ))}
          </div>
          {items.length === 0 && <p className="text-brand-text/60" data-testid="events-empty">Bu kategoride yaklaşan etkinlik yok.</p>}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((e, i) => {
              const unlimited = e.remaining == null;
              const full = !unlimited && e.remaining <= 0;
              return (
                <Reveal key={e.id} delay={(i % 3) * 0.08}>
                  <Link to={`/etkinlikler/${e.slug}`} onClick={() => track("event_view", { event: e.title })} data-testid={`event-card-${e.slug}`}
                    className="group block h-full bg-brand-cream border border-brand-gold-light/40 rounded-sm overflow-hidden transition-transform duration-300 hover:-translate-y-1.5 hover:border-brand-gold">
                    <div className="h-44 overflow-hidden relative">
                      <img src={e.cover} alt={e.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      <span className="absolute top-3 left-3 bg-brand-green text-brand-offwhite text-xs px-2 py-1 rounded">{e.category}</span>
                      {full && <span className="absolute top-3 right-3 bg-red-700 text-white text-xs px-2 py-1 rounded">Dolu</span>}
                    </div>
                    <div className="p-6">
                      <h3 className="font-serif text-2xl text-brand-green leading-tight">{e.title}</h3>
                      <div className="mt-3 space-y-1.5 text-sm text-brand-text/60">
                        <p className="flex items-center gap-2"><Calendar size={14} className="text-brand-gold" /> {(e.start || e.date || "").replace("T", " ")}</p>
                        <p className="flex items-center gap-2">{e.is_online ? <Globe size={14} className="text-brand-gold" /> : <MapPin size={14} className="text-brand-gold" />} {e.location}</p>
                        <p className="flex items-center gap-2"><Users size={14} className="text-brand-gold" /> {full ? "Kontenjan dolu" : unlimited ? "Sınırsız kontenjan" : `${e.remaining} kişilik yer`}</p>
                      </div>
                      <div className="mt-4 font-semibold text-brand-green">{e.price > 0 ? money(e.price) : "Ücretsiz"}</div>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
